<div *ngIf="showSnackBar" [ngClass]="{'show': showSnackBar, 'black': snackBarData?.theme == 'black', 'default': snackBarData?.theme == 'white'}" [ngStyle]="snackbarStyles"
     aria-live="assertive"
     id="snackbar" role="alert">
    <button (click)="close()" *ngIf="snackBarData?.closeOption" aria-label="close" class="close" tabindex="1"
            type="button">
        <div *ngIf="snackBarData?.theme == 'black'">
            <img alt="" aria-hidden="true" src="ocsp-web-ui/assets/images/icon/Web/close/white.svg">
        </div>
        <div *ngIf="snackBarData?.theme == 'white'">
            <img alt="" aria-hidden="true" src="/erums/store/dist/assets/images/close_cross.svg"
                 style="height: 15px;margin-top: 4px; margin-right: 4px;">
        </div>
    </button>
    <span class="d-flex">
        <img alt="error icon" aria-hidden="true" attr.aria-label="error" class="tooltip-link pb-1 float-left m-2" role="img"
             src="ocsp-web-ui/assets/images/icon/Web/error/negative_red.svg"/>
        <p [innerHtml]="snackBarBody"
           [ngClass]="[(1==1)?'message text-left fs-16 mb-1 mt-1 pr-3 font-weight-bold':'', (showSnackBar)?'d-block':'d-none' ]"></p>
    </span>
</div>
